import * as React from 'react';
import {
  Create,
  Datagrid,
  DeleteButton,
  Edit,
  EditButton,
  List,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
} from 'react-admin';
import Row from '../ui/Row';
import { useAdminAccessContext } from '../hooks/useAdminAccessContext';

export const DeviceManufacturerList: React.FC = () => {
  const { context, isPending } = useAdminAccessContext();
  if (isPending || !context) return null;
  const canManage = !context.enforcementEnabled || context.globalAdmin;

  return (
    <List title='Device Manufacturers' actions={canManage ? undefined : false}>
      <Datagrid size='medium' rowClick={false} bulkActionButtons={canManage ? undefined : false}>
        <TextField label='Slug' source='slug' />
        <TextField label='Name' source='name' />
        {canManage ? (
          <Toolbar>
            <EditButton label='' size='small' variant='outlined' />
            <DeleteButton mutationMode='optimistic' label='' size='small' variant='outlined' />
          </Toolbar>
        ) : null}
      </Datagrid>
    </List>
  );
};

export const DeviceManufacturerCreate: React.FC = () => (
  <Create title='Create Device Manufacturer' redirect='list'>
    <SimpleForm>
      <Row>
        <TextInput label='Slug' source='slug' size='large' />
        <TextInput label='Name' source='name' size='large' />
      </Row>
    </SimpleForm>
  </Create>
);

export const DeviceManufacturerEdit: React.FC = () => (
  <Edit title='Edit Device Manufacturer'>
    <SimpleForm>
      <Row>
        <TextInput label='Slug' source='slug' size='large' />
        <TextInput label='Name' source='name' size='large' />
      </Row>
    </SimpleForm>
  </Edit>
);

const deviceManufacturer = {
  list: DeviceManufacturerList,
  create: DeviceManufacturerCreate,
  edit: DeviceManufacturerEdit,
};

export default deviceManufacturer;
